var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkTransferBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5 16c30.253 0 30 13.431 30 30 0 16.569.457 30-30 30s-30-13.431-30-30c0-16.569-.255-30 30-30z",
    fill: "#1C1C1E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.51 58.874c6.594.594 12.42-4.607 13.014-11.617.593-7.01-4.271-13.175-10.866-13.77-6.594-.594-12.42 4.607-13.014 11.618-.594 7.01 4.27 13.175 10.865 13.77z",
    fill: "#fff",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.666 55.05a.76.76 0 0 1-.523-.229.728.728 0 0 1-.207-.522v-1.503l-.608-.12a5.002 5.002 0 0 1-.424-.092 3.47 3.47 0 0 1-1.8-1.191 3.347 3.347 0 0 1-.723-2.006v-.295c0-.197-.007-.39 0-.58a.709.709 0 0 1 .235-.463.74.74 0 0 1 .984 0c.134.12.218.285.235.463.008.172 0 .341 0 .51v.34c.008.508.216.992.581 1.353.366.36.859.57 1.377.583.26.008.52.012.781.013.305 0 .609 0 .912-.013a2.042 2.042 0 0 0 1.296-.475 1.938 1.938 0 0 0 .419-2.51 2.007 2.007 0 0 0-1.076-.854c-.532-.182-1.07-.357-1.609-.533l-.215-.07c-.502-.162-1.003-.323-1.5-.492a3.47 3.47 0 0 1-1.768-1.238 3.35 3.35 0 0 1-.67-2.025 3.35 3.35 0 0 1 .693-2.017 3.473 3.473 0 0 1 1.782-1.218c.137-.035.73-.157.73-.157l.365-.079v-1.504a.7.7 0 0 1 .197-.517.73.73 0 0 1 .803-.173.712.712 0 0 1 .46.666v1.587l.405.043c.8.08 1.546.427 2.117.98.322.306.578.672.755 1.075.177.404.271.837.276 1.277v.845c0 .19-.076.371-.213.505a.738.738 0 0 1-1.032 0 .707.707 0 0 1-.214-.505V43.089a1.938 1.938 0 0 0-.583-1.375 2.023 2.023 0 0 0-1.403-.577 27.41 27.41 0 0 0-.837-.012c-.282 0-.563 0-.851.012-.474.01-.93.181-1.287.486a1.963 1.963 0 0 0-.42 2.492c.237.395.608.697 1.049.851.877.304 1.756.586 2.636.865l.533.169a3.492 3.492 0 0 1 1.926 1.27c.474.627.715 1.394.683 2.174a3.374 3.374 0 0 1-.863 2.11 3.508 3.508 0 0 1-2.026 1.113l-.65.098v1.456a.744.744 0 0 1-.395.75.755.755 0 0 1-.279.08l-.054-.002z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.257 46.217c0 7.195-5.662 12.991-12.601 12.991-6.94 0-12.601-5.796-12.601-12.991 0-7.196 5.662-12.991 12.6-12.991 6.94 0 12.602 5.795 12.602 12.99z",
    stroke: "url(#c)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M48.606 58.749c2.502-.6 4.761-2.02 6.453-4.053 1.692-2.034 2.73-4.577 2.963-7.264.233-2.687-.35-5.38-1.664-7.69-1.315-2.311-3.294-4.121-5.653-5.17a13.583 13.583 0 0 1 4.54 5.521 14.434 14.434 0 0 1 1.22 7.195 14.324 14.324 0 0 1-2.44 6.858 13.373 13.373 0 0 1-5.42 4.603z",
    fill: "#6AC34B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m40.773 28.299-4.343 1.216",
    stroke: "#00A6CE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.748 31.92 35.389 27 32 30.786l4.748 1.133z",
    stroke: "#00A6CE",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m52.227 63.701 4.343-1.216",
    stroke: "#00A6CE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m56.252 60.08 1.36 4.92L61 61.214l-4.748-1.133z",
    stroke: "#00A6CE",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 45.427,
    y1: 31.53,
    x2: 45.849,
    y2: 60.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 45.656,
    y1: 32.476,
    x2: 45.656,
    y2: 59.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.5,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1632_12455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1632_12455",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTransferBalance);
export default __webpack_public_path__ + "static/media/darkTransferBalance.9c793b80a352a026cb908759649a1499.svg";
export { ForwardRef as ReactComponent };